import React, { useState } from 'react';
import { Layout } from './components/Layout';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TherapySection } from './components/TherapySection';
import { HowItWorks } from './components/HowItWorks';
import { StorySection } from './components/StorySection';
import { BodySection } from './components/BodySection';
import { CommunitySection } from './components/CommunitySection';
import { PrivacySection } from './components/PrivacySection';
import { TherapistsSection } from './components/TherapistsSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { WaitlistModal } from './components/WaitlistModal';
export function App() {
  const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);
  const openWaitlistModal = () => setIsWaitlistModalOpen(true);
  const closeWaitlistModal = () => setIsWaitlistModalOpen(false);
  return <Layout data-id="element-0">
      <Navbar onOpenWaitlist={openWaitlistModal} data-id="element-1" />
      <Hero onOpenWaitlist={openWaitlistModal} data-id="element-2" />
      <TherapySection data-id="element-3" />
      <HowItWorks data-id="element-4" />
      <StorySection data-id="element-5" />
      <BodySection data-id="element-6" />
      <CommunitySection data-id="element-7" />
      <PrivacySection data-id="element-8" />
      <TherapistsSection onOpenWaitlist={openWaitlistModal} data-id="element-9" />
      <CtaSection onOpenWaitlist={openWaitlistModal} data-id="element-10" />
      <Footer data-id="element-11" />
      <WaitlistModal isOpen={isWaitlistModalOpen} onClose={closeWaitlistModal} data-id="element-12" />
    </Layout>;
}